import form from 'ngtemplate-loader!./template.tpl.html';
import "./styles";

export const moduleName = 'rezflow.rebook'
export const name = 'rebook';

const ELEMENT = new WeakMap();
const DOCUMENT = new WeakMap();

export default (MODULE) => {

  class Rebook {

    /* @ngInject */
    constructor($document, $element, $timeout) {
      const vm = this;
      this.$timeout = $timeout;
      ELEMENT.set(this, $element);
      DOCUMENT.set(this, $document);
      DOCUMENT.get(this).on('click', (event) => {
        this.clickAway(event)
      });
    }

    clickAway(event) {
      const $element = ELEMENT.get(this);
      const isChild = $element.find(event.target).length > 0;
      if(!isChild) {
        if(this.active) this.$timeout(() => this.active = false)
      }
    }

    update() {
      const update = this.booking.update;
      const moveTo = moment.utc(this.rebook, 'MM/DD/YYYY');
      const bookingDay = moment.utc(this.booking.day);

      if(!moveTo.isSame(bookingDay, 'days')) {
        update({ day: moveTo.toDate() }).then(res => {
          if(res.status) {
            if(res.status === 'success') {
              this.active = false;
              this.$timeout(() => {
                this.then();
              }, 500)
            }
          }
        })
      }
      
    }

    $onDestroy() {
      const $document = DOCUMENT.get(this);
      $document.off('click', (event) => {
        this.clickAway(event)
      });
    }

    $onInit() {
      this.rebook = moment.utc(angular.copy(this.booking.day)).format('MM/DD/YYYY');
    }

  }

  angular.module(MODULE)
    .component(name, {
      bindings: {
        booking: '=',
        active: '<',
        then: '&'
      },
      transclude: true,
      templateUrl: form,
      controller: Rebook
    });

  return name;

};


// WEBPACK FOOTER //
// ./client/assets/scripts/modules/reservations/rebook/popover.js